import Select from '@/components/Form/Select.jsx'

const options = [
    ['Basic'],
    ['DTO'],
    ['List'],
    ['Other'],
]

const SelectBasicDataType = (props) => {
    return (
        <Select
            style={{display: 'block'}}
            options={options}
            {...props}
        />
    )
}

export default SelectBasicDataType
